(function (){
    'use strict';

    angular
        .module('commissionsPayment', []);
})();